// assets/titan-ai.js
(() => {
  // ====== 設定 ======
  const WORKER_URL = "https://pc-ai-relay.vercel.app/api/chat";
  const SESSION_KEY = "ai_session_id";
  const STORAGE_KEY = "ai_chat_history_v1";
  const GUARD_KEY   = "ai_chat_guard_v1";
  const BLOCK_KEY   = "ai_spam_blocked_v1";
  const KEEP_MS = 7*24*60*60*1000;

  const RATE_MS = 1000;
  const SPAM_WINDOW = 30 * 1000;
  const SPAM_LIMIT  = 7;
  const REPEAT_LIMIT = 15;
  const UNLOCK_CODE = "たいたんちゃんかわいい";
  const BLOCK_TTL   = 24*60*60*1000;

  const HINT_KEY   = "ai_hint_hidden_ts";
  const HINT_TTL   = 24*60*60*1000;

  /* リクエスト署名（curl直叩き防止） */
  const _SALT = 'T1t4nG#2025xQ';
  function _djb2(s){let h=5381;for(let i=0;i<s.length;i++){h=((h<<5)+h+s.charCodeAt(i))>>>0;}return h.toString(36);}
  function _sign(){const t=Math.floor(Date.now()/1000);return{_t:t,_k:_djb2(_SALT+':'+t)};}

  const ready = (cb) => {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", cb);
    else cb();
  };

  ready(() => {
    // ====== CSS注入 ======
    const style = document.createElement("style");
    style.textContent = `
      :root{
        --ai-brand:#06C755;
        --ai-brand-hover:#05B14B;
        --ai-border:#e3e9f2;
        --ai-text:#1f2937;
        --ai-ai:#ffffff;
        --banner-h:48px;
      }

      /* #ai-bubble の CSS は全て titan-config-save.liquid で管理 (iOS Safari 対策) */
      #ai-hint{ display:none; }

      /* 初回案内はパネル表示後に退避する。 */
      body.ai-panel-open .titan-ai-coach{
        opacity:0 !important;
        visibility:hidden !important;
        pointer-events:none !important;
      }

      /* 全面表示になるスマホでは起動FABもパネルの後ろへ退避する。
         PCではパネル直下に残し、同じボタンで閉じられるようにする。 */
      @media (max-width:600px){
        body.ai-panel-open .titan-ai-fab{
          opacity:0 !important;
          visibility:hidden !important;
          pointer-events:none !important;
        }
      }

      /* ===== パネル（PC版） ===== */
      #ai-panel{
        position:fixed; left:16px; bottom:70px; z-index:99999;
        width:420px; max-width:95vw; height:560px;
        background:#fff; border:1px solid var(--ai-border); border-radius:18px; overflow:hidden;
        box-shadow:0 18px 46px rgba(0,0,0,.18);
        display:none; grid-template-rows: 56px 1fr var(--banner-h) auto;
      }

      /* ===== スマホ版：フルスクリーンパネル ===== */
      @media (max-width:600px){
        #ai-panel{
          position:fixed;
          top:0; left:0; right:0; bottom:0;
          width:100%; height:100%;
          max-width:100vw;
          border-radius:0;
          border:none;
          grid-template-rows: 52px 1fr var(--banner-h) auto;
        }
        /* パネル表示中はbodyスクロール無効 */
        body.ai-panel-open{
          overflow:hidden !important;
          position:fixed !important;
          width:100% !important;
          height:100% !important;
        }
      }

      /* ヘッダー */
      #ai-head{
        grid-row:1; background:var(--ai-brand); color:#fff;
        display:flex; align-items:center; gap:8px; padding:0 10px;
      }
      .ai-title{ font-weight:800; font-size:16px; flex:1; padding-left:4px; }
      .ai-head-btn{ border:none; background:rgba(255,255,255,.18); color:#fff; height:32px; padding:0 10px; border-radius:10px; cursor:pointer; }
      .ai-close-btn{ border:none; background:transparent; color:#fff; font-size:22px; width:34px; height:34px; cursor:pointer; }

      @media (max-width:600px){
        #ai-head{ padding:0 8px; }
        .ai-title{ font-size:14px; }
        .ai-head-btn{ font-size:12px; padding:0 8px; height:28px; }
        .ai-close-btn{ font-size:26px; width:40px; height:40px; }
      }

      /* ログ */
      #ai-log{
        grid-row:2; position:relative; min-height:0;
        overflow-y:auto; overflow-x:hidden;
        -webkit-overflow-scrolling:touch;
        overscroll-behavior:contain;
        padding:14px 10px 10px; font-size:14px; line-height:1.7;
        background: linear-gradient(180deg, #d8ecff 0%, #eaf4ff 40%, #f6f9fc 100%);
      }
      #ai-log[data-empty="1"]{
        background:
          url('https://cdn.shopify.com/s/files/1/0772/5681/8928/files/syagami.png?v=1767099926') center 35% / 140px no-repeat,
          linear-gradient(180deg, #d8ecff 0%, #eaf4ff 40%, #f6f9fc 100%);
      }
      #ai-log::before{
        content:attr(data-placeholder);
        position:absolute; left:50%; top:80%; transform:translate(-50%,-50%);
        font-size:13px; color:#9aa4b2; pointer-events:none; display:none;
      }
      #ai-log[data-empty="1"]::before{ display:block; }
      #ai-log .ai-spacer{ height:1px; visibility:hidden; }

      @media (max-width:600px){
        #ai-log{
          padding:12px 8px 10px;
          font-size:13px;
        }
        #ai-log[data-empty="1"]{
          background:
            url('https://cdn.shopify.com/s/files/1/0772/5681/8928/files/syagami.png?v=1767099926') center 30% / 100px no-repeat,
            linear-gradient(180deg, #d8ecff 0%, #eaf4ff 40%, #f6f9fc 100%);
        }
        #ai-log::before{
          top:60%;
          font-size:12px;
        }
      }

      /* 下側バナー */
      #ai-bottom-banner{
        grid-row:3; border-top:1px solid var(--ai-border); background:#f8fbff; color:#0f172a;
        padding:8px 12px; font-size:12px; line-height:1.6; display:flex; align-items:center; gap:10px;
        height:var(--banner-h); overflow:hidden; opacity:1; transition:opacity .2s ease;
      }
      #ai-bottom-banner .ok{ margin-left:auto; border:none; background:#0ea5e9; color:#fff; padding:6px 10px; border-radius:8px; cursor:pointer; flex-shrink:0; }

      @media (max-width:600px){
        #ai-bottom-banner{
          padding:6px 10px;
          font-size:11px;
          gap:8px;
        }
        #ai-bottom-banner .ok{
          padding:5px 8px;
          font-size:11px;
        }
      }

      /* 入力エリア */
      #ai-input-row{
        grid-row:4; display:flex; gap:8px; padding:6px 10px; border-top:1px solid var(--ai-border); background:#fff;
        align-items:flex-end;
      }
      #ai-input{ flex:1; padding:8px 12px; border:1px solid #cfd8e3; border-radius:14px; font-size:14px; min-width:0; font-family:inherit; line-height:1.4; resize:none; min-height:36px; max-height:140px; overflow-y:auto; white-space:pre-wrap; }
      #ai-send{ padding:0 16px; min-width:72px; height:36px; border:none; border-radius:12px; background:var(--ai-brand); color:#fff; font-weight:800; cursor:pointer; flex-shrink:0; }

      @media (max-width:600px){
        #ai-input-row{
          padding:8px;
          padding-bottom:max(8px, env(safe-area-inset-bottom));
          gap:6px;
        }
        #ai-input{
          padding:8px 12px;
          font-size:16px; /* iOS zoom防止 */
          border-radius:12px;
          min-height:40px;
          max-height:140px;
        }
        #ai-send{
          min-width:64px;
          padding:0 12px;
          height:42px;
          font-size:14px;
          border-radius:12px;
        }
      }

      /* メッセージ */
      .ai-msg{ display:flex; margin:8px 0; }
      .ai-left{ justify-content:flex-start } .ai-right{ justify-content:flex-end }
      .ai-inner{ max-width:76%; display:flex; flex-direction:column; }
      .ai-bubble{ position:relative; padding:10px 12px; border-radius:18px; word-break:break-word; white-space:pre-wrap; }
      .ai-left .ai-bubble{ background:var(--ai-ai); color:var(--ai-text); }
      .ai-right .ai-bubble{ background:var(--ai-brand); color:#fff; }
      .ai-time{ margin:2px 6px 0; font-size:11px; color:#8b98a5; }

      @media (max-width:600px){
        .ai-msg{ margin:6px 0; }
        .ai-inner{ max-width:82%; }
        .ai-bubble{ padding:9px 11px; border-radius:16px; font-size:13px; }
        .ai-time{ font-size:10px; }
      }

      /* タイピングアニメ */
      .ai-typing{
        background:#fff; border:1px solid #e6ebf3; border-radius:16px;
        padding:8px 10px; display:inline-flex; gap:6px; align-items:center;
        box-shadow:0 2px 6px rgba(0,0,0,.06);
      }
      .ai-typing i{ width:6px; height:6px; border-radius:50%; background:#a8b3c2; display:inline-block; animation:blink 1.2s infinite ease-in-out; }
      .ai-typing i:nth-child(2){ animation-delay:.15s; }
      .ai-typing i:nth-child(3){ animation-delay:.30s; }
      @keyframes blink{ 0%,80%,100%{opacity:.3; transform:translateY(0);} 40%{opacity:1; transform:translateY(-2px);} }

      /* ===== AI返信内リンクボタン（Engineered Minimal） ===== */
      /* 精密機器のような静かな存在感。左端の太めの色ボーダーで識別 */
      .ai-link-btn{
        display:inline-flex; align-items:center; gap:8px;
        margin:8px 6px 2px 0; padding:8px 12px 8px 12px;
        background:#ffffff;
        color:#111827 !important;
        text-decoration:none !important;
        border-radius:4px;
        border:1px solid #dde3ec;
        border-left:3px solid #94a3b8;
        font-size:12.5px; font-weight:600; line-height:1.2;
        letter-spacing:.005em;
        font-family:-apple-system,BlinkMacSystemFont,"Helvetica Neue","Hiragino Sans","Yu Gothic UI",sans-serif;
        box-shadow:0 1px 2px rgba(15,23,42,.04);
        transition:
          background .14s ease,
          border-color .14s ease,
          transform .08s ease,
          box-shadow .14s ease;
      }
      .ai-link-btn:hover{
        background:#f8fafc;
        border-color:#b8c2d1;
        box-shadow:0 2px 4px rgba(15,23,42,.08);
        transform:translateY(-1px);
      }
      .ai-link-btn:active{
        transform:translateY(0);
        box-shadow:0 1px 1px rgba(15,23,42,.06);
      }
      .ai-link-btn:focus-visible{
        outline:none;
        box-shadow:0 0 0 3px rgba(6,199,85,.22);
      }
      .ai-link-btn .ai-link-ico{
        width:13px; height:13px; flex:0 0 13px;
        display:inline-flex; align-items:center; justify-content:center;
        opacity:.7;
        transition:opacity .14s ease;
      }
      .ai-link-btn:hover .ai-link-ico{ opacity:1; }
      .ai-link-btn .ai-link-ico svg{
        width:100%; height:100%; display:block; stroke-width:1.75;
      }

      /* === カテゴリー別: 左ボーダーの色のみで識別 === */
      .ai-link-btn.search{ border-left-color:#06C755; }
      .ai-link-btn.search:hover{ border-color:#9ad9b2; border-left-color:#06C755; }
      .ai-link-btn.contact{ border-left-color:#4f46e5; }
      .ai-link-btn.contact:hover{ border-color:#c7d2fe; border-left-color:#4f46e5; }
      .ai-link-btn.product{ border-left-color:#ea580c; }
      .ai-link-btn.product:hover{ border-color:#fed7aa; border-left-color:#ea580c; }
      .ai-link-btn.other{ border-left-color:#94a3b8; }

      /* モバイル */
      @media (max-width:600px){
        .ai-link-btn{
          font-size:12px;
          padding:7px 11px 7px 11px;
          gap:7px;
        }
        .ai-link-btn .ai-link-ico{
          width:12px; height:12px; flex:0 0 12px;
        }
      }
    `;
    document.head.appendChild(style);

    // ====== HTML挿入 ======
    // #ai-bubble が既に存在する場合（Liquid から出力済み）はそれを使う
    // 存在しない場合のみ JS で作成
    let aiBubbleEl = document.getElementById('ai-bubble');
    if (!aiBubbleEl) {
      aiBubbleEl = document.createElement('div');
      aiBubbleEl.id = 'ai-bubble';
      aiBubbleEl.setAttribute('aria-label', 'AI で相談');
      aiBubbleEl.setAttribute('title', 'AI で相談');
      aiBubbleEl.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M4 4h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9l-5 5v-5H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/></svg><span class="ai-bubble-text">AI で相談</span>';
      document.body.appendChild(aiBubbleEl);
    }

    const wrap = document.createElement("div");
    wrap.innerHTML = `
      <div id="ai-hint">AI で相談</div>

      <div id="ai-panel" role="dialog" aria-modal="false" aria-label="TITAN Gaming 相談Bot">
        <div id="ai-head">
          <span class="ai-title">TITAN Gaming 相談Bot</span>
          <button class="ai-head-btn" id="ai-clear" title="ログ全消去">会話消去</button>
          <button class="ai-close-btn" id="ai-close" aria-label="AI相談を閉じる">×</button>
        </div>

        <div id="ai-log" aria-live="polite" aria-relevant="additions"
             data-empty="1" data-placeholder="会話はまだありません、寂しい..."></div>

        <div id="ai-bottom-banner">
          <span>回答は必ずしも正しいとは限りません。重要な事は必ず直接お問い合わせください。</span>
          <button class="ok" id="ai-bottom-ok">OK</button>
        </div>

        <div id="ai-input-row">
          <textarea id="ai-input" rows="1" placeholder="質問を入力 (Shift+Enterで送信)" autocomplete="off"></textarea>
          <button id="ai-send">送信</button>
        </div>
      </div>
    `;
    document.body.appendChild(wrap);

    // ====== ユーティリティ ======
    const qs = (id) => document.getElementById(id);
    const isMobile = () => window.innerWidth <= 600;

    const nowTime = () => {
      const d = new Date();
      return `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
    };
    const bubble = (t) => {
      const el = document.createElement("div");
      el.className = "ai-bubble";
      el.textContent = t;
      return el;
    };

    // ▼ AI返信用: 平文テキスト内のURLを検出してボタン化
    // - XSS対策: テキストは textContent で挿入、URLのみ createElement('a')
    // - titan-pc.net 以外のリンクも一律ボタン化（ただしラベル違い）
    const URL_RE = /(https?:\/\/[^\s、。　<>"'`]+)/g;
    // インラインSVG (Heroicons / Feather風の線画アイコン、stroke=currentColor)
    const SVG = {
      search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>',
      contact: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>',
      product: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2l-3 5v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-3-5z"/><path d="M3 7h18"/><path d="M16 11a4 4 0 0 1-8 0"/></svg>',
      doc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>',
      external: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><path d="M10 14L21 3"/></svg>'
    };
    const linkButtonFor = (url) => {
      const trimmed = url.replace(/[.,、。;:!?)\]}]+$/, "");
      let kind = "other", svg = SVG.external, label = "リンクを開く";
      try {
        const u = new URL(trimmed);
        const host = u.hostname.replace(/^www\./, "");
        if (host === "titan-pc.net") {
          if (u.pathname.startsWith("/search") || u.pathname === "/search") {
            const q = u.searchParams.get("q") || "";
            kind = "search"; svg = SVG.search;
            label = q ? `${q} を探す` : "商品を探す";
          } else if (u.pathname.startsWith("/pages/contact")) {
            kind = "contact"; svg = SVG.contact; label = "お問い合わせ";
          } else if (u.pathname.startsWith("/products/")) {
            kind = "product"; svg = SVG.product; label = "商品を見る";
          } else if (u.pathname.startsWith("/policies/")) {
            kind = "other"; svg = SVG.doc; label = "ポリシー";
          } else {
            kind = "other"; svg = SVG.external; label = "詳細を見る";
          }
        }
      } catch (_) { /* URL parse fail → 既定値 */ }
      const a = document.createElement("a");
      a.className = `ai-link-btn ${kind}`;
      a.href = trimmed;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      const ico = document.createElement("span");
      ico.className = "ai-link-ico";
      ico.setAttribute("aria-hidden", "true");
      ico.innerHTML = svg; // 固定のSVG文字列のみ、ユーザー入力無し
      const lbl = document.createElement("span");
      lbl.textContent = label;
      a.appendChild(ico); a.appendChild(lbl);
      return { node: a, url: trimmed };
    };
    const bubbleRich = (t) => {
      const el = document.createElement("div");
      el.className = "ai-bubble";
      if (typeof t !== "string" || !t) { el.textContent = t || ""; return el; }
      // URLを検出しつつ、前後テキストは textContent で安全に挿入
      let lastIdx = 0;
      const matches = [];
      let m;
      URL_RE.lastIndex = 0;
      while ((m = URL_RE.exec(t)) !== null) {
        matches.push({ idx: m.index, raw: m[0] });
      }
      if (matches.length === 0) { el.textContent = t; return el; }
      matches.forEach(({ idx, raw }) => {
        if (idx > lastIdx) {
          el.appendChild(document.createTextNode(t.slice(lastIdx, idx)));
        }
        const { node, url } = linkButtonFor(raw);
        el.appendChild(node);
        // URL文字列末尾で改行があれば保持するために lastIdx を進める
        lastIdx = idx + raw.length;
      });
      if (lastIdx < t.length) el.appendChild(document.createTextNode(t.slice(lastIdx)));
      return el;
    };
    const typingBubble = () => {
      const el = document.createElement("div");
      el.className = "ai-typing";
      el.innerHTML = "<i></i><i></i><i></i>";
      return el;
    };

    // ▼ ヒント表示制御
    function hideHintFor24h() {
      const hint = qs("ai-hint");
      if (hint) hint.style.display = "none";
      try { localStorage.setItem(HINT_KEY, String(Date.now())); } catch (_) { /* storage unavailable */ }
    }
    function shouldShowHint() {
      let ts = 0;
      try { ts = Number(localStorage.getItem(HINT_KEY) || 0); } catch (_) { return false; }
      if (!ts) return true;
      return (Date.now() - ts) >= HINT_TTL;
    }
    if (!shouldShowHint()) {
      const hint = qs("ai-hint");
      if (hint) hint.style.display = "none";
    }

    function updateEmptyState(){
      const elLog = qs("ai-log");
      elLog.querySelectorAll(".ai-spacer").forEach(n => n.remove());
      const hasMsg = !!elLog.querySelector(".ai-msg");
      elLog.setAttribute("data-empty", hasMsg ? "0" : "1");
      const spacer = document.createElement("div"); spacer.className = "ai-spacer";
      elLog.appendChild(spacer);
    }

    function appendMsg(role, node){
      const elLog = qs("ai-log");
      const row = document.createElement("div"); row.className = "ai-msg " + (role==="user" ? "ai-right":"ai-left");
      const inner = document.createElement("div"); inner.className = "ai-inner";
      const time = document.createElement("div"); time.className = "ai-time"; time.textContent = nowTime();
      inner.appendChild(node); inner.appendChild(time); row.appendChild(inner);
      elLog.appendChild(row); elLog.scrollTop = elLog.scrollHeight;
      updateEmptyState();
      return row;
    }

    // 履歴
    function loadHistory(){
      let arr=[]; try{ arr=JSON.parse(localStorage.getItem(STORAGE_KEY)||"[]"); }catch(_){}
      const cutoff = Date.now()-KEEP_MS;
      arr = arr.filter(m => (m.ts||0) >= cutoff);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
      for(const m of arr){ appendMsg(m.role, (m.role === "assistant" ? bubbleRich(m.text) : bubble(m.text))); }
      updateEmptyState();
    }
    function saveMessage(role, text){
      let arr=[]; try{ arr=JSON.parse(localStorage.getItem(STORAGE_KEY)||"[]"); }catch(_){}
      const now=Date.now(), cutoff=now-KEEP_MS;
      arr.push({role, text, ts: now});
      arr = arr.filter(m => (m.ts||0) >= cutoff);
      if(arr.length>500) arr = arr.slice(arr.length-500);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    }
    function clearHistory(){
      const log = qs("ai-log");
      log.querySelectorAll(".ai-msg").forEach(n => n.remove());
      localStorage.removeItem(STORAGE_KEY);
      log.scrollTop = 0;
      updateEmptyState();
    }
    function getHistoryForServer(){
      try{
        const arr = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
        return arr.map(m => ({ role: m.role, content: m.text })).slice(-40);
      }catch(_){ return []; }
    }

    // スパム
    function getGuard(){
      try{ return JSON.parse(localStorage.getItem(GUARD_KEY) || '{"events":[],"lastMsgs":[]}'); }
      catch(_){ return {events:[], lastMsgs:[]}; }
    }
    function setGuard(g){ localStorage.setItem(GUARD_KEY, JSON.stringify(g)); }
    function isBlocked(){
      const raw = localStorage.getItem(BLOCK_KEY);
      if(!raw) return false;
      try{
        const o = JSON.parse(raw);
        if(Date.now() - (o.ts||0) >= BLOCK_TTL){ localStorage.removeItem(BLOCK_KEY); return false; }
        return true;
      }catch(_){ localStorage.removeItem(BLOCK_KEY); return false; }
    }
    function setBlocked(v){ v ? localStorage.setItem(BLOCK_KEY, JSON.stringify({ ts: Date.now() })) : localStorage.removeItem(BLOCK_KEY); }
    function recordAndCheckSpam(msg){
      const now = Date.now();
      const g = getGuard();
      g.events = (g.events||[]).filter(t => now - t < SPAM_WINDOW);
      g.events.push(now);
      const MSG_WINDOW = 60*1000;
      g.lastMsgs = (g.lastMsgs||[]).filter(m => now - m.ts < MSG_WINDOW);
      g.lastMsgs.push({text: msg, ts: now});
      if (g.events.length > SPAM_LIMIT) { setGuard(g); return true; }
      if (g.lastMsgs.filter(m => m.text === msg).length >= REPEAT_LIMIT) { setGuard(g); return true; }
      setGuard(g); return false;
    }
    function resetGuard(){ localStorage.removeItem(GUARD_KEY); setBlocked(false); }

    // バナー
    let bannerClosed = false;
    function collapseBannerAnimated(){
      if (bannerClosed) return;
      bannerClosed = true;
      const panel  = qs("ai-panel");
      const banner = qs("ai-bottom-banner");
      const start = parseInt(getComputedStyle(panel).getPropertyValue("--banner-h")) || 48;
      const end = 0, dur = 220;
      const t0 = performance.now();
      function tick(t){
        const p = Math.min(1, (t - t0) / dur);
        panel.style.setProperty("--banner-h", `${start + (end - start)*p}px`);
        banner.style.opacity = String(1 - p);
        if (p < 1) {
          requestAnimationFrame(tick);
        } else {
          banner.style.display = "none";
        }
      }
      requestAnimationFrame(tick);
    }

    // スクロール位置保存（モバイル用）
    let savedScrollY = 0;

    // Googleウィジェット表示/非表示
    // 注: 走査範囲は <body> 直下の固定/絶対配置要素に限定する。
    //     全DOM (`*`) を走査するとSVG等で `el.id` が文字列でない要素に当たり throw する。
    function setGoogleWidgetDisplay(displayValue) {
      try {
        document.querySelectorAll('iframe').forEach(function(iframe) {
          var src = typeof iframe.src === 'string' ? iframe.src : '';
          if (src.indexOf('merchant') !== -1) {
            iframe.style.setProperty('display', displayValue, 'important');
          }
        });
        document.querySelectorAll('[id*="merchant"], [class*="merchant"]').forEach(function(el) {
          el.style.setProperty('display', displayValue, 'important');
        });
      } catch (e) { /* no-op */ }
    }
    function hideGoogleWidget() { setGoogleWidgetDisplay('none'); }
    function showGoogleWidget() { setGoogleWidgetDisplay('block'); }

    function syncAiFabState(isOpen) {
      const fab = document.querySelector('.titan-ai-fab');
      if (!fab) return;
      fab.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      fab.setAttribute('aria-label', isOpen ? 'AI相談を閉じる' : 'AIに相談してゲーミングPCを選ぶ');
      fab.setAttribute('title', isOpen ? 'AI相談を閉じる' : 'AIに相談して選ぶ');
    }

    // UI 開閉
    function showPanel(){
      const panel=qs("ai-panel"), hint=qs("ai-hint");

      document.body.classList.add("ai-panel-open");
      panel.setAttribute('aria-modal', isMobile() ? 'true' : 'false');
      syncAiFabState(true);

      if (isMobile()) {
        savedScrollY = window.scrollY;
        document.body.style.top = `-${savedScrollY}px`;
        hideGoogleWidget();
      }

      panel.style.display="grid";
      if (hint) hideHintFor24h();

      setTimeout(() => {
        qs("ai-log").scrollTop = qs("ai-log").scrollHeight;
        if (!isMobile()) {
          qs("ai-input").focus();
        }
      }, 100);
    }

    function hidePanel(){
      const panel = qs("ai-panel");
      const closeHadFocus = document.activeElement === qs("ai-close");
      panel.style.display="none";

      document.body.classList.remove("ai-panel-open");
      syncAiFabState(false);

      if (isMobile()) {
        document.body.style.top = "";
        window.scrollTo(0, savedScrollY);
        showGoogleWidget();
      }

      if (closeHadFocus) {
        const fab = document.querySelector('.titan-ai-fab');
        if (fab) setTimeout(() => fab.focus(), 0);
      }
    }

    // 返信表示＋保存 (v: URLボタン化対応)
    function renderAndSaveAssistant(typingRow, text){
      const inner = typingRow.querySelector(".ai-inner");
      inner.replaceChild(bubbleRich(text), inner.firstChild);
      try{ saveMessage("assistant", text); }catch(_){}
    }

    // 送信
    let sessionId = localStorage.getItem(SESSION_KEY);
    if(!sessionId){
      sessionId = "s_" + Math.random().toString(36).slice(2) + Date.now();
      localStorage.setItem(SESSION_KEY, sessionId);
    }
    let sending = false;
    let lastSendTime = 0;

    async function sendBase(msg, retryCount = 0, typingRow = null){
      if (msg === UNLOCK_CODE) {
        resetGuard();
        // 診断側のクライアント制限もクリア
        try {
          localStorage.removeItem('wz_diag_hour_v1');
          localStorage.removeItem('wz_guard_v1');
          localStorage.removeItem('wz_blocked_v1');
          // 診断UI残り回数表示も更新
          var diagEl = document.getElementById('wzDiagRemain');
          if (diagEl) {
            diagEl.textContent = '残り10回';
            diagEl.className = 'wz-diag-remain';
          }
        } catch(_){}
        if (!typingRow){
          const typing = typingBubble();
          typingRow = appendMsg("assistant", typing);
        }
        renderAndSaveAssistant(typingRow, "制限を解除しました！チャット・診断どちらも回数がリセットされました✨");
        return { done: true };
      }
      if (isBlocked()) {
        if (!typingRow){
          const typing = typingBubble();
          typingRow = appendMsg("assistant", typing);
        }
        renderAndSaveAssistant(typingRow, "スパムと検知されました、数日後に再度お試しください。");
        return { done: true };
      }
      const now = Date.now();
      if (retryCount === 0 && (now - lastSendTime < RATE_MS)) {
        if (!typingRow){
          const typing = typingBubble();
          typingRow = appendMsg("assistant", typing);
        }
        renderAndSaveAssistant(typingRow, "少し待ってから送信してください💢");
        return { done: true };
      }
      if (retryCount === 0 && recordAndCheckSpam(msg)) {
        setBlocked(true);
        if (!typingRow){
          const typing = typingBubble();
          typingRow = appendMsg("assistant", typing);
        }
        renderAndSaveAssistant(typingRow, "スパムと検知されました、数日後に再度お試しください。");
        return { done: true };
      }

      const createdTypingRow = !typingRow;
      if (createdTypingRow) {
        appendMsg("user", bubble(msg));
        saveMessage("user", msg);
        const typing = typingBubble();
        typingRow = appendMsg("assistant", typing);
      } else {
        const inner = typingRow.querySelector(".ai-inner");
        inner.replaceChild(bubble(`スパム防止の為お待ちください、再試行します… (${retryCount}/3)`), inner.firstChild);
      }

      try{
        const history = getHistoryForServer();
        const sig = _sign();
        const res = await fetch(WORKER_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            message: msg,
            sessionId,
            history,
            model: "gpt-5.6-luna",
            _t: sig._t,
            _k: sig._k,
            source: "chat"
          }),
        });

        let payload = {};
        try { payload = await res.json(); } catch(_){ payload = {}; }

        if(!res.ok){
          if (payload?.error === "DAILY_LIMIT_REACHED") {
            const text = (payload?.message || "24時間あたりの上限に達しました。") +
                         "\n解除するには特定のパスワードを送信してください。";
            renderAndSaveAssistant(typingRow, text);
            return { done: true };
          }
          if (payload?.error === "TOO_MANY_REQUESTS") {
            const sec = Number(payload?.retryAfterSec) || 10;
            const text = (payload?.message || "短時間に連続送信されています。") + `\n約 ${sec} 秒お待ちください。`;
            renderAndSaveAssistant(typingRow, text);
            return { done: true };
          }
          if (retryCount < 3){
            const inner = typingRow.querySelector(".ai-inner");
            inner.replaceChild(bubble(`通信エラー。再試行します… (${retryCount+1}/3)`), inner.firstChild);
            setTimeout(()=> sendBase(msg, retryCount+1, typingRow), 1500);
            return { done:false, retrying:true };
          } else {
            renderAndSaveAssistant(typingRow, "再試行に失敗しました。再度お試しください。");
            return { done: true };
          }
        }

        let text = "普通のエラーです、再度お試しください。";
        for(const k of ["answer","reply","message","text"]){
          if(payload && typeof payload[k]==="string" && payload[k].trim()){ text=payload[k]; break; }
        }
        renderAndSaveAssistant(typingRow, text);
        lastSendTime = Date.now();
        return { done: true };

      }catch(err){
        if (retryCount < 3){
          const inner = typingRow.querySelector(".ai-inner");
          inner.replaceChild(bubble(`通信エラー。再試行します… (${retryCount+1}/3)`), inner.firstChild);
          setTimeout(()=> sendBase(msg, retryCount+1, typingRow), 1500);
          return { done:false, retrying:true };
        } else {
          renderAndSaveAssistant(typingRow, "再試行に失敗しました。再度お試しください。");
          return { done: true };
        }
      }
    }

    async function send(){
      const elInput = qs("ai-input");
      const elSend  = qs("ai-send");
      const msg = (elInput.value||"").trim();
      if(!msg) return;
      if(sending) return;

      elInput.disabled = true;
      elSend.disabled = true;
      const prevPlaceholder = elInput.placeholder;
      elInput.placeholder = "送信中…";
      elInput.value = "";
      elInput.style.height = "";

      if (isMobile()) {
        elInput.blur();
      }

      sending = true;
      collapseBannerAnimated();

      await sendBase(msg, 0, null);

      elInput.disabled = false;
      elSend.disabled = false;
      elInput.placeholder = prevPlaceholder;
      sending = false;

      if (!isMobile()) {
        elInput.focus();
      }
    }

    // 外部から確実に開くためのAPI（main-product.liquidなどから利用）
    window.titanOpenAI = function(prefillText){
      try {
        showPanel();
        if (typeof prefillText === "string" && prefillText) {
          setTimeout(function(){
            const input = qs("ai-input");
            if (input) {
              input.value = prefillText;
              if (!isMobile()) input.focus();
            }
          }, 150);
        }
      } catch(e) { /* no-op */ }
    };

    // 画面上のAI丸ボタン用。PCではパネル表示中も残し、同じボタンで閉じられるようにする。
    window.titanToggleAI = function(){
      try {
        const panel = qs("ai-panel");
        if (panel && panel.style.display === "grid") hidePanel();
        else showPanel();
      } catch(e) { /* no-op */ }
    };

    // 初期化
    function init(){
      qs("ai-bubble").onclick = () => {
        const panel = qs("ai-panel");
        if (panel.style.display === "grid") hidePanel();
        else showPanel();
      };
      qs("ai-close").onclick  = hidePanel;
      qs("ai-send").onclick   = send;
      qs("ai-input").addEventListener("keydown", e => {
        // Shift+Enter or Ctrl/Cmd+Enter で送信 / 単独Enterは改行
        if(e.key==="Enter" && (e.shiftKey || e.ctrlKey || e.metaKey)){
          e.preventDefault();
          send();
        }
      });
      // textarea 自動リサイズ (内容に合わせて高さ調整)
      const _autosize = () => {
        const el = qs("ai-input");
        if (!el) return;
        el.style.height = "auto";
        el.style.height = Math.min(el.scrollHeight, 160) + "px";
      };
      qs("ai-input").addEventListener("input", _autosize);
      // 外部から value 設定された後にもautosizeを掛けられるよう公開
      window.titanAIAutosizeInput = _autosize;
      qs("ai-bottom-ok").onclick = collapseBannerAnimated;
      qs("ai-clear").onclick = () => { clearHistory(); };

      window.addEventListener("popstate", () => {
        if (qs("ai-panel").style.display === "grid") {
          hidePanel();
        }
      });

      loadHistory();
setTimeout(()=> {
  const greeting = document.createElement("div");
  greeting.className = "ai-bubble";
  greeting.style.cssText = "white-space:normal;padding:12px 14px;";
  greeting.innerHTML = '<div style="margin-bottom:10px;font-size:14px;line-height:1.6;">こんにちは！PC選びのお手伝いをします。</div>' +
    '<a href="/pages/%E3%82%B2%E3%83%BC%E3%83%A0%E3%81%8B%E3%82%89%E9%81%B8%E3%81%B6" style="display:flex;align-items:center;gap:10px;padding:10px;margin-bottom:6px;background:linear-gradient(135deg,#eef4ff,#f5f0ff);border-radius:10px;color:#1a1a1a;text-decoration:none;transition:opacity 0.15s;" onmouseover="this.style.opacity=\'0.8\'" onmouseout="this.style.opacity=\'1\'">' +
      '<span style="width:36px;height:36px;border-radius:8px;background:#fff;display:flex;align-items:center;justify-content:center;font-size:18px;box-shadow:0 1px 3px rgba(0,0,0,0.08);flex-shrink:0;color:initial;">🎮</span>' +
      '<span style="flex:1;min-width:0;"><span style="font-size:13px;font-weight:700;display:block;line-height:1.3;">AIゲーミングPC診断</span><span style="font-size:11px;color:#888;line-height:1.3;">予算や用途からAIがぴったりの1台を提案</span></span>' +
      '<span style="color:#ccc;font-size:18px;flex-shrink:0;">›</span>' +
    '</a>' +
    '<a href="/pages/%E3%82%88%E3%81%8F%E3%81%82%E3%82%8B%E8%B3%AA%E5%95%8F" style="display:flex;align-items:center;gap:10px;padding:10px;background:#f7f7f7;border-radius:10px;color:#1a1a1a;text-decoration:none;transition:opacity 0.15s;" onmouseover="this.style.opacity=\'0.8\'" onmouseout="this.style.opacity=\'1\'">' +
      '<span style="width:36px;height:36px;border-radius:8px;background:#fff;display:flex;align-items:center;justify-content:center;font-size:18px;box-shadow:0 1px 3px rgba(0,0,0,0.08);flex-shrink:0;color:initial;">📋</span>' +
      '<span style="flex:1;min-width:0;"><span style="font-size:13px;font-weight:700;display:block;line-height:1.3;">よくある質問</span><span style="font-size:11px;color:#888;line-height:1.3;">納期・保証・支払い方法など</span></span>' +
      '<span style="color:#ccc;font-size:18px;flex-shrink:0;">›</span>' +
    '</a>' +
    '<div style="margin-top:10px;font-size:13px;line-height:1.4;">他に聞きたいことがあればお気軽にどうぞ！</div>';
  appendMsg("assistant", greeting);
}, 250)
    }

    init();
  });
})();
